/**
 * Location requests
 */
import API from '@/api/base.js';
import CONFIG from '@/constants/config.js';
export default {

    contact(data){
        let d=(data)?data:{};
        d.type=(null==d.type)?CONFIG.MESSAGE_TYPE_CONTACT:d.type;
        return API.post('/message',d,'Contact');
    },
    booking_request(data){
        let d=(data)?data:{};
        d.type=(null==d.type)?CONFIG.MESSAGE_TYPE_BOOKING_REQUEST:d.type;
        return API.post('/message',d,'Booking Request');
    },
    newsletter(data){
        let d=(data)?data:{};
        d.type=CONFIG.MESSAGE_TYPE_NEWSLETTER_REQUEST;
        return API.post('/message',d,'Newsletter');
    },
    confirmNewsletter(data){
        return API.post('/newsletter',data,'Confirm Newsletter');
    }
}